import { pickDto } from './auto-refill.utils';

/** Facilities for the selected pharmacy, sorted by name. */
export function buildFacilityOptions(facilities: any[]): any[] {
  var list = (facilities || []).slice();
  list.sort(function (a, b) {
    var na = String(pickDto(a, 'name', 'Name') || '').toLowerCase();
    var nb = String(pickDto(b, 'name', 'Name') || '').toLowerCase();
    if (na < nb) {
      return -1;
    }
    if (na > nb) {
      return 1;
    }
    return 0;
  });
  return list;
}

export function findFacility(facilities: any[], pharmacyId: number, facilityId: number): any {
  if (facilityId <= 0 || pharmacyId <= 0 || !facilities) {
    return null;
  }
  var i = 0;
  for (i = 0; i < facilities.length; i++) {
    var row = facilities[i];
    var rowPharmacyId = parseInt(String(pickDto(row, 'pharmacyId', 'PharmacyId') || '0'), 10);
    var rowFacilityId = parseInt(String(pickDto(row, 'id', 'Id') || '0'), 10);
    if (rowPharmacyId === pharmacyId && rowFacilityId === facilityId) {
      return row;
    }
  }
  return null;
}

export function facilitySelectLabel(facilities: any[], pharmacyId: number, facilityId: number): string {
  if (facilityId <= 0) {
    return 'All';
  }
  var f = findFacility(facilities, pharmacyId, facilityId);
  return f ? String(pickDto(f, 'name', 'Name') || '') : '';
}
